(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["goodwe-sidebar-menu-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const observers = new WeakMap();
    const selector = '.gw-sidebar-menu ecx-sidebar-menu';
    const initialize = (root) => {
      root.querySelectorAll(selector).forEach(async (menu) => {
        await customElements.whenDefined('ecx-sidebar-menu');
        if (!menu.isConnected || observers.has(menu)) return;
        const observer = new ResizeObserver(() => {
          if (matchMedia('(min-width: 1025px)').matches && !menu.closest('.menu-drawer')) {
            menu.syncHeight(false);
          }
        });
        menu.querySelectorAll('.sidebar-mega__panel').forEach((panel) => observer.observe(panel));
        observers.set(menu, observer);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((menu) => {
        observers.get(menu)?.disconnect();
        observers.delete(menu);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["goodwe-video-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('goodwe-video-banner')) {
    customElements.define('goodwe-video-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.videos = Array.from(this.querySelectorAll('video'));
        this.mobile = matchMedia('(max-width: 767px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inViewport = false;
        this.readyForVideo = document.readyState === 'complete';
        this.connection = navigator.connection;
        if (!this.readyForVideo) {
          window.addEventListener('load', () => {
            this.readyForVideo = true;
            this.updatePlayback();
          }, { once: true, signal: this.controller.signal });
        }

        this.videos.forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.controls = false;
          video.playsInline = true;
          video.loop = true;
          video.removeAttribute('controls');
          video.removeAttribute('autoplay');
          video.querySelector('img')?.remove();
          video.addEventListener('playing', () => {
            if (video === this.activeVideo && this.inViewport) video.classList.add('is-playing');
          }, { signal: this.controller.signal });
          video.addEventListener('error', () => video.classList.remove('is-playing'), { signal: this.controller.signal });
        });

        this.selectVideo = () => {
          const mobileVideo = this.videos.find((video) => video.dataset.device === 'mobile');
          this.activeVideo = this.mobile.matches && mobileVideo ? mobileVideo : this.videos[0];
          this.videos.forEach((video) => {
            video.hidden = video !== this.activeVideo;
            if (video !== this.activeVideo) {
              video.pause();
              video.classList.remove('is-playing');
            }
          });
          this.updatePlayback();
        };

        this.updatePlayback = () => {
          const video = this.activeVideo;
          if (!video) return;
          if (!this.readyForVideo || !this.inViewport || document.hidden || this.reducedMotion.matches || this.connection?.saveData) {
            video.pause();
            if (this.reducedMotion.matches) video.classList.remove('is-playing');
            return;
          }
          if (!video.dataset.loaded) {
            video.querySelectorAll('source[data-src]').forEach((source) => {
              source.src = source.dataset.src;
            });
            video.dataset.loaded = 'true';
            video.load();
          }
          video.play()?.catch(() => video.classList.remove('is-playing'));
        };

        this.mobile.addEventListener('change', this.selectVideo, { signal: this.controller.signal });
        this.reducedMotion.addEventListener('change', this.updatePlayback, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', this.updatePlayback, { signal: this.controller.signal });
        this.observer = new IntersectionObserver((entries) => {
          this.inViewport = entries[0].isIntersecting;
          this.updatePlayback();
        }, { threshold: 0.05 });
        this.selectVideo();
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.videos?.forEach((video) => video.pause());
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
